import _ from 'lodash'
import { router } from '_/router/router'
import { store } from '_/vuex/store'

export default function(event, action) {
  const instance = $.jstree.reference(this)
  const node = instance.get_node(this)
  if (store.state.admin.parentSelectionActive) {
    selectParentNode(node)
  } else {
    selectNode(node)
  }
}

function selectNode(node) {
  const entryId = _.get(store.state.admin.editedEntry, 'system.id')

  const tableName = store.state.admin.selectedModule.table_name

  // Do not reload if currently edited node is doubleclicked
  if (
    node.original.tableName === tableName &&
    node.original.originalId === entryId
  ) {
    return false
  }

  // Do not allow loading of nodes that belong to a different module
  if (node.original.tableName !== tableName) {
    return false
  }

  router.push(`/admin/${node.original.tableName}/${node.original.originalId}`)
}

function selectParentNode(node) {
  if (
    !(
      store.state.admin.editorMode === 'create' ||
      store.state.admin.editorMode === 'default'
    )
  ) {
    return
  }

  let parentId = null
  let scopeId = null

  // If a selected node belongs to a parent module
  if (node.original.tableName !== store.state.admin.selectedModule.table_name) {
    scopeId = node.original.originalId
  }

  if (node.original.tableName === store.state.admin.selectedModule.table_name) {
    parentId = node.original.originalId

    scopeId = node.original.scopeId
  }

  store.dispatch('admin/updateSelectedNode', {
    anchorText: node.original.text,
    id: node.original.originalId,
    url: `${node.original.tableName}/${node.original.originalId}`,
    parentId,
    scopeId,
  })
  store.dispatch('admin/toggleParentSelectionMode')
}
